import React from 'react';
import { motion } from 'framer-motion';
import { Card } from './ui/Card';
import { Droplets, Activity, BatteryWarning } from 'lucide-react';
export function PainPoints() {
  const points = [{
    icon: <Droplets className="w-10 h-10 text-[#C67B5C]" data-id="element-60" />,
    title: 'Retención de Líquidos',
    description: '¿Tus anillos te aprietan al despertar? ¿Sientes las manos y pies hinchados por la mañana?',
    bg: 'bg-[#FFFDF5]'
  }, {
    icon: <Activity className="w-10 h-10 text-[#C67B5C]" data-id="element-61" />,
    title: 'Rigidez Matutina',
    description: 'El líquido inflamatorio se acumula en tus rodillas y articulaciones mientras duermes, haciendo que los primeros pasos del día duelan.',
    bg: 'bg-[#FFFDF5]'
  }, {
    icon: <BatteryWarning className="w-10 h-10 text-[#C67B5C]" data-id="element-62" />,
    title: 'Fatiga Digestiva',
    description: 'Tu cuerpo gasta su valiosa energía procesando cenas pesadas en lugar de sanar tus tejidos durante la noche.',
    bg: 'bg-[#FFFDF5]'
  }];
  return <section className="py-20 px-4 bg-white" data-id="element-63">
      <div className="max-w-5xl mx-auto" data-id="element-64">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-65">
          <h2 className="text-3xl md:text-4xl font-bold text-[#5C3D2E] mb-6" data-id="element-66">
            La Ciencia de la Hinchazón después de los 65
          </h2>
          <p className="text-xl text-[#5C3D2E] max-w-3xl mx-auto" data-id="element-67">
            En Estados Unidos, los alimentos están cargados de sodio y
            conservantes que "oxidan" tus articulaciones. Tu cuerpo procesa
            estos químicos más lento, causando:
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-68">
          {points.map((point, index) => <Card key={index} delay={index * 0.2} className={`${point.bg} border-t-4 border-t-[#C67B5C]`} data-id="element-69">
              <div className="p-8 flex flex-col items-center text-center" data-id="element-70">
                <div className="w-20 h-20 rounded-full bg-white shadow-md flex items-center justify-center mb-6 border border-[#FFF8E7]" data-id="element-71">
                  {point.icon}
                </div>
                <h3 className="text-2xl font-bold text-[#5C3D2E] mb-4" data-id="element-72">
                  {point.title}
                </h3>
                <p className="text-lg text-[#5C3D2E] opacity-90" data-id="element-73">
                  {point.description}
                </p>
              </div>
            </Card>)}
        </div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.8
      }} className="mt-16 text-center p-8 bg-[#FFF8E7] rounded-2xl border border-[#D4A017]/30" data-id="element-74">
          <p className="text-2xl font-serif text-[#5C3D2E] italic" data-id="element-75">
            "La mayoría te dice 'come lechuga'. Aquí vamos a hacer lo contrario.
            Usaremos el calor de una sola olla para que los ingredientes liberen
            su poder medicinal."
          </p>
        </motion.div>
      </div>
    </section>;
}